import React, { Component } from 'react';
//import FreeScrollBar from 'react-free-scrollbar';
import { observer } from 'mobx-react';
import './CoverLyrics.css';

import { DataStore } from '../DataStore';

@observer
class CoverLyrics extends Component {

    lightPosition = () => {
        let indexArr = [];
        for (let i = 0; i < DataStore.coutSongMassge.Lyrics.length; i++) {
            if (DataStore.currentTime  > DataStore.coutSongMassge.Lyrics[i][0]) {
                indexArr.push(i);
            };
        };
        return indexArr[indexArr.length - 1];
    }

    listItems = () => {
        if(DataStore.coutSongMassge.Lyrics.length > 0) {
            return DataStore.coutSongMassge.Lyrics.map((item,index) => 
                <li key ={index} className={this.lightPosition() === index ? 'cur' : ''}>{item[1]}</li>
            );
        }else{
            return null;
        }
    }

    marginSize = () => {
        let row = 5;
        let mid = Math.floor(row/2);
        let step = 0;
        if(this.lightPosition() - mid < 0) {
            step = 0;
        }else if(DataStore.coutSongMassge.Lyrics.length - this.lightPosition() < row) {
            step = DataStore.coutSongMassge.Lyrics.length - row;
        }else{
            step = this.lightPosition() - mid
        }
        return -50 * step + 'px';
    }

    render() {
    
        return (
            <div className="cover-lyrics">
                <div className="cover-box">
                    <div className="cover-img">
                        <img src={DataStore.coutSongMassge.Img} 
                            alt={DataStore.coutSongMassge.SongName + '-' +DataStore.coutSongMassge.SingerName}/>
                    </div> 
                    <div className="cover-song-msg">
                        <p>歌曲名：{DataStore.coutSongMassge.SongName}</p>
                        <p>歌手名：{DataStore.coutSongMassge.SingerName}</p>
                        <p>专辑名：{DataStore.coutSongMassge.AlbumName}</p>
                    </div>   
                </div>
                <div className="lyrics-box">
                    <ul style={{marginTop:this.marginSize()}}>
                        {this.listItems()}
                    </ul>
                </div>
            </div>
        );
    }
}

export default CoverLyrics;


// WEBPACK FOOTER //
// ./src/components/CoverLyrics.js